export const PLATFORM = "web"
